import { Navigate, Route, Routes } from 'react-router-dom';
import IntroPage from './pages/IntroPage';
import MapPage from './pages/MapPage';
import EnigmaPage from './pages/EnigmaPage';
import CompletePage from './pages/CompletePage';
import './FestaHistoria.css';

/**
 * Secção oculta (sem links no menu).
 * QR Code → /festa-historia
 */
export default function FestaHistoriaApp() {
  return (
    <div className="fh-root">
      <Routes>
        <Route index element={<IntroPage />} />
        <Route path="mapa" element={<MapPage />} />
        <Route path="enigma/:id" element={<EnigmaPage />} />
        <Route path="concluido" element={<CompletePage />} />
        <Route path="*" element={<Navigate to="/festa-historia" replace />} />
      </Routes>
    </div>
  );
}
